var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecording = function SvgRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.022 26.535A13.015 13.015 0 1 0 0 13.515a13.1 13.1 0 0 0 13.022 13.02Zm0-2.593A10.417 10.417 0 1 1 23.44 13.515a10.37 10.37 0 0 1-10.418 10.42v.007Zm.011-5.488a4.941 4.941 0 1 0-1.894-.376 4.933 4.933 0 0 0 1.895.372l-.001.004Z",
    fill: "#fff"
  })));
};
export default SvgRecording;